<script setup lang="ts">
withDefaults(
  defineProps<{
    modelValue?: string
    label: string
    name: string
    disabled?: boolean
    required?: boolean
    error?: string
    min?: string
    max?: string
  }>(),
  {}
)
</script>

<template>
  <label class="block">
    <span class="mb-1 text-sm font-bold text-gray-500">
      {{ label }} {{ !required ? `(${$t('forms.optional')})` : '' }}
    </span>
    <input
      :name="name"
      :value="modelValue"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
      @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
      @change="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
      :class="[
        'mt-1 block w-full rounded-md border-gray-300 shadow-sm transition focus:ring focus:ring-primary-normal focus:ring-opacity-50',
      ]"
      type="date"
      :required="required"
      :disabled="disabled"
      :min="min"
      :max="max"
    />
    <ErrorMessage v-if="error" :error="error" />
  </label>
</template>
